import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { SelectOption, SupportTicket } from '../../../globals/interfaces';
import Select from 'react-select';
import useAssignableUsers from './useAssignableUsers';
import { safeGet } from '../../../utils';
import { CreateUpdateTicketWithParam } from './SupportRequestModal';

const defaultOwnership = { label: 'None', value: null };

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    ticket: SupportTicket;
    setOwnership: (value: string | null) => void;
    createUpdateTicketWithParam: CreateUpdateTicketWithParam;
}

export default function AssignUserModal ({
    modal,
    setModal,
    ticket,
    setOwnership,
    createUpdateTicketWithParam
}: Props) {

    const assignableUsers = useAssignableUsers();
    const options: Array<SelectOption> = assignableUsers.map((item) => {
        return { 
            label: item.email,
            value: item.email
        }
    });
    const [selectedOption, setSelectedOption] = useState(defaultOwnership);
    const handleSelectOption = (option: SelectOption) => {
        setSelectedOption(option);
        setOwnership(option.value ? String(option.value) : null);
    }

    useEffect(() => {
        if (ticket && ticket.assignedTo) {
            setSelectedOption({ label: ticket.assignedTo, value: ticket.assignedTo });
        } else {
            setSelectedOption(defaultOwnership);   
        }
    }, [ticket])

    const toggle = () => setModal(!modal);

    if (!ticket) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Assign Ticket: {ticket.unit}-{ticket.id}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <Select 
                    options={[
                        defaultOwnership,
                        ...options
                    ]}
                    value={selectedOption}
                    onChange={option => handleSelectOption(option)}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={createUpdateTicketWithParam(undefined, true)} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;